import { useCallback } from "react";
import { differenceInDays, parseISO } from "date-fns";
import { LocalSearchType } from "./useMarkSearchUpdate";
const useTrackSearchClick = () => {
  return useCallback((search: LocalSearchType) => {
    if (!search) return;

    // Extract and format the search term for tracking
    const searchTerm = (search.shortName?.replace(/--/g, ", ").replace(/-/g, " ") || "")?.split(",");
    // TODO update this because it won't be home page always
    localStorage.setItem("searchPageOrigin", "home page");

    // Load the mixpanel client dynamically and trigger the event
    void (async () => {
      const mixpanelV1Client = (await import("services/mixpanel")).mixpanelV1Client;
      mixpanelV1Client.SEARCH_CLICKED({
        addDays: differenceInDays(parseISO(search?.endDate || ""), parseISO(search?.startDate || "")),
        searchTermOrDestionation: search.shortName || "",
        checkInDate: search.startDate || "Not selected",
        checkOutDate: search.endDate || "Not selected",
        adultsCount: search.adultCount || 0,
        childrenCount: search.childrenCount || 0,
        petsAllowed: search.petAllowed || false,
        dateSelected: !!(search.startDate && search.endDate),
        city: searchTerm.length > 2 ? searchTerm[0] : "NA",
        state: searchTerm.length > 2 ? searchTerm[1] : searchTerm.length > 1 ? searchTerm[0] : "NA",
        country: searchTerm.length > 2 ? searchTerm[2] : searchTerm.length > 1 ? searchTerm[1] : searchTerm[0],
        latitude: search.lat || 0,
        longitude: search.lng || 0,
        searchedCity: searchTerm.length > 2 ? searchTerm[0] : "NA",
        searchedState: searchTerm.length > 2 ? searchTerm[1] : searchTerm.length > 1 ? searchTerm[0] : "NA"
      });
    })();
  }, []);
};
export default useTrackSearchClick;